// extracted by mini-css-extract-plugin
module.exports = {"playerWrap":"Player_playerWrap__36OH2","playerWrapFullScreen":"Player_playerWrapFullScreen__2JOkH","a11yToggle":"Player_a11yToggle__2ZSZ6"};